import type { Factory } from 'walden-fast/types/mocks';
import type { OffsetAggregated } from 'walden-fast/types/offset-aggregated';

const MOCK_OFFSET_AGGREGATED: OffsetAggregated = {
  totalOffsetCo2TonnesMtd: 138.6,
  totalOffsetCo2TonnesYtd: 721,
  totalTreesIncludedMtd: 23,
  totalTreesIncludedYtd: 162,
  totalTreesNonIncludedMtd: 57,
  totalTreesNonIncludedYtd: 782,
  totalWorkingHoursMtd: 21,
  totalWorkingHoursYtd: 362,
};

export const offsetAggregatedFactory: Factory<OffsetAggregated> = (
  overrides,
) => ({
  ...MOCK_OFFSET_AGGREGATED,
  ...overrides,
});
